module.exports = {
  changeEmail: 'Sí, cambiar mi dirección',
  dontChangeEmail: 'No, mantener mi dirección actual',
  yes: 'Sí',
  no: 'No',
  'go-back-wizard': '',
  'next-step-wizard': '',
  step: '',
  off: '',
  'next-step': 'Siguiente',
  'last-step': 'Recibe ofertas personalizadas',
  'go-back': 'Volver',
  understood: '¡Entendido!',
  'company-placeholder': 'Empresa SL',
  'company-label': 'Nombre de la empresa',
  'address-placeholder': 'Calle, número y piso',
  address_no_number_placeholder: 'Calle sin número',
  'address-label': 'Dirección',
  'address-street-number-label': 'Número',
  'address-street-number-placeholder': '10',
  'address-no-street-number-label': 'Sin número',
  'address-not-found': 'No se encuentra la dirección',
  'address-no-match': 'La dirección indicada no existe',
  'address-choose-from': 'Elige una dirección',
  'address-invalid': 'La dirección no es válida',
  'address-missing-street-number': 'Introduce el número de la calle',
  address_alert: '¿Has escrito la dirección correcta?',
  address_missing_city: 'Introduce la localidad',
  'company-autocomplete-label': '',
  'zip-label': 'Código postal',
  'zip-does-not-exist': 'El código postal indicado no existe',
  zip_placeholder: '01234',
  'name-label': 'Nombre y apellidos',
  'first-name': 'Nombre',
  'last-name': 'Apellidos',
  'date-format': 'ddmmaa',
  'date-label': 'Fecha (ddmmaa)',
  'birthdate-label': 'Fecha de nacimiento (ddmmaa)',
  'national-identity-label': 'DNI o NIE',
  'national-identity-placeholder': 'Todos los números y letras',
  'national-identity-invalid': 'El número de identidad no es válido',
  'national-identity-identical':
    'El número de identidad del cotitular no puede ser el mismo que el del titular',
  'bank-account-label': 'Número de cuenta bancaria (IBAN)',
  'measuring-id-invalid': 'El código del contador no es válido',
  'bank-account-placeholder': '24 cifras',
  'bank-account-invalid': 'El número de cuenta no es válido',
  'organization-identity-label': 'NIF de la empresa',
  'organization-identity-placeholder': 'Todos los números y letras',
  'organization-identity-invalid': 'El NIF de la empresa no es válido',
  'date-invalid': 'La fecha no es válida',
  'name-placeholder': 'Nombre y apellidos',
  'first-name-placeholder': 'Nombre',
  'last-name-placeholder': 'Apellidos',
  'name-invalid': 'El nombre no es válido',
  'email-alert-message': '¿Has escrito la dirección de correo correcta?',
  'email-label': 'Correo electrónico',
  'email-placeholder': 'Correo electrónico',
  'email-does-not-exist': 'La dirección de correo electrónico no existe',
  'email-invalid': 'La dirección de correo electrónico no es válida',
  email_did_you_mean: 'Querías decir',
  'comment-label': 'Información adicional',
  'comment-placeholder':
    'Opcional: Algo que quieras añadir sobre ti, lo que necesitas o algo que debamos saber para ofrecerte un mejor servicio',
  'phone-alert-message': '¿Has escrito el número de teléfono correcto?',
  'phone-label': 'Número de teléfono',
  'phone-invalid': 'El número de teléfono no es válido',
  'phone-must-begin-with-+': 'El número de teléfono debe empezar con el signo +',
  'phone-foreign': 'Número de teléfono extranjero',
  'phone-placeholder': '123456789',
  'phone-foreign-placeholder-prefix': '+34',
  'error-x-numbers': 'Debe contener --x-- números',
  'error-x-letters': 'Debe contener --x-- caracteres',
  'error-min-x-letters': 'Debe contener al menos --x-- letras',
  'error-min-x-numbers': 'Debe contener al menos --x-- números',
  'error-max-x-numbers': 'Debe contener como máximo --x-- números',
  'error-inbetween-numbers': 'Debe contener entre --x------y números',
  'error-must-consist-of-x-letters': 'Debe contener al menos --x-- letras',
  'error-mandatory': 'Campo obligatorio',
  'error-choose': 'Elige al menos --x-- alternativa(s)',
  'error-min-age': 'Esta oferta es únicamente para personas mayores de --x-- años',
  'error-must-accept': 'Debes aceptar',
  privacy:
    ' <strong>Protegemos tu privacidad:</strong> Tus datos se encriptan y se envían al servidor a través de una conexión segura.',
  'privacy-policy':
    '<h4>Política de privacidad</h4><p>Tu privacidad es importante para nosotros en --x--. Como usuario, te aseguramos que la información que nos proporciones no se va a utilizar para ninguna otra finalidad que aquella para la que des tu consentimiento, y que tus datos se almacenarán de forma segura.</p><p>Los datos que solicitamos en los formularios son el mínimo requerido por los proveedores de electricidad para proporcionarte ofertas personalizadas. Estos datos se utilizan únicamente para enviarte dichas ofertas en un periodo de tiempo determinado, respetando tus deseos en cuando al tiempo y forma en los que podremos comunicarnos contigo.</p><p>Las ofertas se enviarán por correo electrónico, SMS o por teléfono.</p><p>El tratamiento de los datos corresponde a la empresa noruega de tecnología Nettbureau AS, proprietaria y gestora del servicio --x--, así como a los proveedores de electricidad correspondientes.</p><p>Tus datos personales se utilizarán de acuerdo con la ley, y serán conservados únicamente durante el tiempo necesario para la prestación del servicio. Transcurrido este tiempo, tus datos serán eliminados o anonimizados.</p><p>Nettbureau se hace responsable de que tus datos personales sean protegidos de forma adecuada.</p><p>Nettbureau utiliza métodos de encriptación de datos para asegurar una comunicación segura con el usuario.</p><p>Lee más en nuestra <a href="https://--x----y--" target="__blank">política de privacidad</a>.</p>',
  close: 'Cerrar',
  error_radio_button: 'Debes elegir una opción',
  invalid_day: 'El día indicado no es válido',
  invalid_day_in_month: 'El día no es válido para el mes indicado',
  invalid_month: 'El mes indicado no es válido',
  invalid_year: 'El año indicado no es válido',
  invalid_input: 'Introduce todos los números y letras sin espacios',
  invalid_country: 'No es un país válido',
  label_birthdate: 'Fecha de nacimiento',
  label_date: 'Día',
  label_month: 'Mes',
  label_year: 'Año',
  locale: 'nb-NB',
  missing_date: 'Introduce el día',
  missing_month: 'Introduce el mes',
  missing_year: 'Introduce el año',
  'datepicker-button': 'Seleccione fecha',
  email_wrong_user_account:
    '¿Está seguro de que la cuenta de usuario de correo electrónico es correcta?',
  email_wrong_email_address: '¿Estás seguro de que la dirección de correo electrónico es correcta?',
  not_valid_municipality: '',
  not_valid_state: 'Indica una provincia',
  placeholder_state_dropdown: 'Provincia',
  label_state_dropdown: 'Provincia',
  no_future_dates: 'La fecha debe ser anterior al día de hoy',
  date_warning: 'Comprueba que la fecha es correcta',
  'sms-verification-label': 'Verificación SMS',
  'sms-verification-tinyLabel':
    'Por favor, introduce el código que has recibido por SMS en el número --xx--',
  'sms-verification-error-message': 'Código incorrecto',
  'sms-verification-code-not-received-first': '¿No has recibido un código? Haz ',
  'sms-verification-code-not-received-link': 'clic aquí para',
  'sms-verification-code-not-received-last': '  recibir uno nuevo.',
  'sms-verification-code-is-sent-again': 'Hemos reenviado el código.',
  'sms-verification-code-retry-error': 'Espera 30 segundos antes de interntarlo de nuevo.',
  'leazard-two-factor-header': 'Ya casi estamos',
  'leazard-two-factor-help-text':
    'Te vamos a enviar un SMS con un código desde el+47 59 44 45 00 para confirmar tu número.',
  'leazard-two-factor-submit': 'Enviado',
  'leazard-two-factor-label': 'Introduce el código para confirmar.',
  'leazard-loading-text': 'Procesando tus datos',
  'recaptcha-disclaimer': 'Este sitio web está protegido por reCAPTCHA.',
};
